import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../features/user/userAPI";
import { toast } from "react-toastify";
import bgImage from "../../assets/images/37.png";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      toast.warn("Reset token missing.");
      navigate("/forgot-password");
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      toast.info("Please fill out all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const response = await resetPassword({ token, newPassword });
      if (response?.status === 200) {
        toast.success("Password reset successful. Please login.");
        navigate("/sign-in");
      } else {
        toast.error(response?.data?.message || "Failed to reset password.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred.");
    }
    setLoading(false);
  };

  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{ backgroundImage: `url(${bgImage})` }}
        ></div>
        <div className="row flex-center position-relative min-vh-100 g-0 py-5">
          <div className="col-11 col-sm-10 col-xl-8">
            <div className="card border border-translucent auth-card">
              <div className="card-body pe-md-0">
                <div className="row align-items-center gx-0 gy-7">
                  <div className="col mx-auto py-12">
                    <div className="auth-form-box">
                      <div className="text-center mb-7">
                        <a
                          className="d-flex flex-center text-decoration-none mb-4"
                          href="/"
                        >
                          <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
                            <img
                              src={
                                localStorage.getItem("phoenixTheme") === "dark"
                                  ? "/assets/img/icons/logo.png"
                                  : "/assets/img/icons/logo-dark.png"
                              }
                              alt="phoenix"
                              width="100"
                            />
                          </div>
                        </a>
                        <h4 className="text-body-highlight">
                          Reset new password
                        </h4>
                        <p className="text-body-tertiary">
                          Type your new password
                        </p>
                      </div>
                      <form className="mt-3" onSubmit={handleSubmit}>
                        <div
                          className="position-relative mb-2"
                          data-password="data-password"
                        >
                          <input
                            className="form-control form-icon-input pe-6"
                            id="password"
                            type="password"
                            placeholder="Type new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                        <div
                          className="position-relative mb-4"
                          data-password="data-password"
                        >
                          <input
                            className="form-control form-icon-input pe-6"
                            id="confirmPassword"
                            type="password"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Setting..." : "Set Password"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ResetPassword;
